import { render, staticRenderFns } from "./AccountingPurchase.vue?vue&type=template&id=54524b1d&"
import script from "./AccountingPurchase.vue?vue&type=script&lang=ts&"
export * from "./AccountingPurchase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports